export default __webpack_public_path__ + "static/media/title_vi_pc.bb80f26c.png";